export default __webpack_public_path__ + "static/media/African cup.0a37ff59.png";